import React from 'react';
import Navigation from '../components/Navigation';
import Logo from '../components/Logo';
import Api_worlds from '../components/Api_worlds';
import background from '../assets/video/background.mp4';

const Home = () => {
    return (
        <div>
            <Logo />
            <Navigation />
            <Api_worlds />
        </div>
    );
};

export default Home;